const config = {
    url: 'https://booksatdoorsteps.com', // Base URL for the API
  }

  export default config
